<template>
  <div class="question-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">

      <div class="m-title flex justify-center">问卷调查</div>

      <el-form :model="form" ref="form" class="form">
        <el-form-item 
          :label="`${index + 1}.`"
          :key="index" 
          v-for="(item, index) in questionList"
        >
          <div class="ques-title">{{ item.name }}</div>
          <el-radio-group v-model="item.value" v-if="Number(item.type) === 1">
            <el-radio 
              v-for="(i, iIndex) in item.options" 
              :key="iIndex" 
              :label="i.value"
            >{{ i.label }}</el-radio>
          </el-radio-group>

          <el-input
            v-model="item.answer"
            v-if="Number(item.type) === 2"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div class="button-box flex justify-center">
        <el-button :loading="loading" @click="submitHandle" type="primary">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { fetchQuestionList, submitQuestion } from '@/api/question'

import { isMobile } from '@/utils/index'

export default {
  data() {
    return {
      form: {},

      object_code: '',
      title: '',

      questionList: [],

      loading: false
    }
  },
  methods: {
    isMobile,

    async getQuestionList() {
      try {
        const data = await fetchQuestionList()

        data.forEach(item => {
          item.value = ''
          item.answer = ''
        })

        this.questionList = data

        console.log(this.questionList)
      } catch (error) {
        console.log(error)
      }
    },

    async submitHandle() { // 编辑提交
      let isLock = false
      for (let i = 0; i < this.questionList.length; i++) {
        const item = this.questionList[i]

        if (Number(item.type) === 1) { // 选择题

          if (!item.value) {
            isLock = true
            break
          }

          item.options.forEach(k => {
            if (k.value === item.value) {
              item.answer = k.label
            }
          })

        } else if (Number(item.type) === 2) { // 问答题 
          if (!item.answer) {
            isLock = true
            break
          }

          item.value = 0
        }
      }

      if (isLock) {
        this.$message.error('存在未填写的问卷题目，请填写')
        return
      }

      console.log(this.questionList)

      const answers = this.questionList.map(i => {

        const o = {
          type: i.type,
          question: i.name,
          question_id: i.id,
          answer: i.answer,
          value: i.value
        }

        if (Number(o.type) === 1) {
          i.options.forEach((k, kIndex) => {
            o[`choice_op${kIndex + 1}`] = k.label
          })
        }

        return o
      })

      console.log(answers)

      try {
        await submitQuestion({
          object_code: this.object_code,
          object_name: this.title,
          answers
        })

        this.loading = false

        // this.$message.success('提交成功')

        this.$router.push({
          name: 'question-success'
        })

      } catch (error) {
        this.loading = false
      }
    },
  },
  created() {
    const { object_code, title } = this.$route.query

    this.object_code = object_code
    this.title = decodeURIComponent(title)

    this.getQuestionList()
  }
}
</script>

<style lang="scss">
.question-container {
  background: $bg;

  .m-title {
    font-size: 18px;
    margin-bottom: 25px;
  }

  .form {
    .el-form-item {
      display: flex;
    }

    .el-form-item__label {
      line-height: initial;
    }

    .el-radio {
      display: block;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .ques-title {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 20px;
    }

    .el-form-item__content {
      flex-grow: 1;
    }
  }


  .button-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;

    .el-button {
      width: 100%;
    }
  }

  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;
    }
  }

  .sys-max-width {
    padding: 49px 0px 71px;

    .title {
      font-size: 16px;
      margin-bottom: 10px;


    }
  }
}
</style>
